export default __webpack_public_path__ + "static/media/avatar_placeholder.dc842f83.jpg";